// extracted by mini-css-extract-plugin
module.exports = {"chromeInstallation":"styles_chromeInstallation__11uw5"};